import { render, staticRenderFns } from "./OrderClientDetails.vue?vue&type=template&id=119b2cd6"
import script from "./OrderClientDetails.vue?vue&type=script&lang=js"
export * from "./OrderClientDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports